import { LOCALE_CHANGE } from './localeActionTypes';


export const localeChange = (locale) => async (dispatch, getState) => {
    console.log(locale);
    //type: LOCALE_CHANGE,
    //locale,
    dispatch({ type: LOCALE_CHANGE, payload: locale });
};
